import { DarkTheme, DefaultTheme, NavigationContainer, createNavigationContainerRef, } from '@react-navigation/native';
import React, { useMemo, useRef } from 'react';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import Analytics from 'src/lib/analytics';
// import {PreferredInitialRoutes} from './config';
import linking from './linking';
export const navigationRef = createNavigationContainerRef();
function useNavigationTheme() {
    const [{ theme }] = useTheme();
    return useMemo(() => {
        const base = theme.themeID === 'dark' ? DarkTheme : DefaultTheme;
        const background = theme.palette.background.main;
        return {
            ...base,
            colors: {
                ...base.colors,
                background,
                card: background,
            },
        };
    }, [theme]);
}
const NavigationWrapper = ({ onReady, ...navigationContainerProps }) => {
    const routeNameRef = useRef('');
    const navigationTheme = useNavigationTheme();
    // const [, setInitialRouteName] = useInitialRouteName();
    return (React.createElement(NavigationContainer, { documentTitle: { enabled: false }, ref: navigationRef, linking: linking, theme: navigationTheme, onReady: () => {
            routeNameRef.current = navigationRef.getCurrentRoute()?.name;
            onReady && onReady();
        }, onStateChange: () => {
            const previousRouteName = routeNameRef.current;
            const currentRouteName = navigationRef.getCurrentRoute()?.name;
            if (previousRouteName !== currentRouteName) {
                // if (PreferredInitialRoutes.includes(currentRouteName as any)) {
                //   setInitialRouteName(currentRouteName as any);
                // }
                Analytics.event
                    .builder()
                    .setPage(currentRouteName ?? 'INIT')
                    .visited();
            }
            // Save the current route name for later comparison
            routeNameRef.current = currentRouteName;
        }, ...navigationContainerProps }));
};
export default NavigationWrapper;
